import { Tooltip as BaseTooltip } from '@base-ui/react/tooltip'
import { TooltipProvider } from './nested/provider'
import { TooltipTrigger } from './nested/trigger'
import { TooltipContent } from './nested/content'
import { TooltipPortal } from './nested/portal'
import { TooltipPositioner } from './nested/positioner'
import { TooltipPopup } from './nested/popup'
import { Kbd } from '../kbd'
import type { PartProps } from '../../lib/part-props'

interface TooltipRootProps extends PartProps<BaseTooltip.Root.Props> {}

function Tooltip({ children, ...props }: TooltipRootProps) {
  return <BaseTooltip.Root {...props}>{children}</BaseTooltip.Root>
}

Tooltip.Provider = TooltipProvider
Tooltip.Trigger = TooltipTrigger
Tooltip.Content = TooltipContent
Tooltip.Portal = TooltipPortal
Tooltip.Positioner = TooltipPositioner
Tooltip.Popup = TooltipPopup
/** The control's hotkey after the label: Kbd, at its default size. */
Tooltip.Hotkey = Kbd

export { Tooltip }
